export default "__VITE_ASSET__BhQN_BX7__"